export function SkeletonRow({ cols = 4, height = 40 }: { cols?: number; height?: number }) {
  return (
    <tr>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i}><div className="skeleton skeleton-line" style={{ height: height - 16 }} /></td>
      ))}
    </tr>
  );
}

export function SkeletonCard({ height = 120 }: { height?: number }) {
  return <div className="skeleton" style={{ height, borderRadius: 14 }} />;
}

export function SkeletonText({ lines = 3, width = "80%" }: { lines?: number; width?: string }) {
  return (
    <div>
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className="skeleton skeleton-line" style={{ width, marginBottom: 8 }} />
      ))}
    </div>
  );
}

export function SkeletonKpi() {
  return <div className="kpi-card skeleton" style={{ height: 120 }} />;
}

export function SkeletonTable({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>{Array.from({ length: cols }).map((_, i) => (<th key={i}><div className="skeleton skeleton-line" style={{ height: 16, width: 80 }} /></th>))}</tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => <SkeletonRow key={i} cols={cols} />)}
        </tbody>
      </table>
    </div>
  );
}
